import {
    ACTION_POST_CREATE_MINDSET,
    ACTION_PUT_UPDATE_MINDSET,
    ACTION_GET_LIST_MINDSETS,
    ACTION_DELETE_MINDSET,
    SET_MINDSETS
} from "@/views/mindset/store/types/types.js"

import config from "@/views/mindset/config/mindset_api.js";
import { MindsetService } from "../../../services";
import axios from '@/plugins/http/axios.js';
import PathUri from '@/utils/path_uri';
import i18n from '@/plugins/i18n';
import Swal from "sweetalert2";

const _pathUri = new PathUri(config.port, config.context);

const actions = {

    [ACTION_GET_LIST_MINDSETS]: async ({ state, commit }) => {
        return new Promise((resolve, reject) => {
            try {
                state.loading = true;
                MindsetService.getListMindsets()
                    .then(resp => {
                        if (resp.data.payload && Array.isArray(resp.data.payload)) {
                            const mindsets = resp.data.payload
                            commit(SET_MINDSETS, mindsets);
                            resolve(resp.data.payload);
                        } else {
                            console.error(i18n.t('label.actionRejectError'), resp);
                            reject(i18n.t('label.actionRejectError'));
                        }
                    })
                    .catch(err => {
                        console.error(i18n.t('label.actionErrorRequest'), err);
                        reject(err);
                    })
                    .finally(() => {
                        state.loading = false;
                    });
            } catch (error) {
                console.error(i18n.t('label.actionErrorRequest'), error);
                reject(error);
            }
        });
    },

    [ACTION_POST_CREATE_MINDSET]: async ({ state, dispatch }, payload) => {        
        return new Promise((resolve, reject) => {
            state.loading = true;
            
            const formdata = new FormData();
            if (payload.urlImagenBienvenida !== undefined && payload.urlImagenBienvenida !== null) {
                formdata.append("imageFile", payload.urlImagenBienvenida);
            }
            formdata.append("titulo", payload.tituloBienvenida);
            formdata.append("cuerpo", payload.cuerpoBienvenida);
            if (payload.linkYoutube !== undefined && payload.linkYoutube !== null && payload.linkYoutube.trim() !== '') {
                formdata.append("linkYoutube", payload.linkYoutube);
            }

            MindsetService.postCreateMindset(formdata)
                .then(async resp => {    
                    Swal.fire({
                        position: 'top-end',
                        icon: 'success',
                        title: i18n.t('mindset.actionCreateMindset.success'),
                        showConfirmButton: false,
                        timer: 2500
                    });
                    // Después de crear exitosamente, obtener la lista actualizada una sola vez
                    await dispatch(ACTION_GET_LIST_MINDSETS);
                    resolve(resp)
                })
                .catch(err => {
                    reject(err)
                })
                .finally(() => state.loading = false);
        })
    },

    [ACTION_PUT_UPDATE_MINDSET]: ({ state, dispatch }, payload) => {
        return new Promise((resolve, reject) => {
            state.loading = true;
            
            const formdata = new FormData();
            if (payload.urlImagenBienvenida !== undefined && payload.urlImagenBienvenida !== null) {
                formdata.append("imageFile", payload.urlImagenBienvenida);
            }
            formdata.append("idImagenEmpresa", payload.idImagenEmpresa);
            formdata.append("titulo", payload.tituloBienvenida);
            formdata.append("cuerpo", payload.cuerpoBienvenida);
            if (payload.linkYoutube !== undefined && payload.linkYoutube !== null && payload.linkYoutube.trim() !== '') {
                formdata.append("linkYoutube", payload.linkYoutube);
            }
            formdata.append("estado", payload.estado);

            MindsetService.putUpdateMindset(formdata)    
            .then(async resp => {   
                    Swal.fire({
                        position: 'top-end',
                        icon: 'success',
                        title: i18n.t('mindset.actionPutUpdateMindset.success'),
                        showConfirmButton: false,
                        timer: 2500
                    });
                    // Después de actualizar exitosamente, obtener la lista actualizada una sola vez
                    await dispatch(ACTION_GET_LIST_MINDSETS);
                    resolve(resp)
                })
                .catch(err => {
                    reject(err)
                })
                .finally(() => state.loading = false);
        })
    },

    [ACTION_DELETE_MINDSET]: async ({ state }, idImagenEmpresa) => {
        return await new Promise((resolve, reject) => {
            state.loading = true;
            axios({
                method: 'delete',
                url: `${config.baseUrl + _pathUri.generateUri() + sessionStorage.getItem("idGroup")}/empresas/eliminar/marcaempresarial/${idImagenEmpresa}`,
                headers: {
                    'idEmpresa': sessionStorage.getItem("idEmpresa"),
                    'idUsuario': sessionStorage.getItem("idUsuario")
                },
                redirect: 'follow'
            })
                .then(async (resp) => {

                    Swal.fire({
                        position: 'top-end',
                        icon: 'success',
                        title: i18n.t('mindset.actionDeleteMindset.success'),
                        showConfirmButton: false,
                        timer: 2500
                    });
                    resolve(resp);

                })
                .catch(err => {
                    reject(err);
                })
                .finally(() => state.loading = false);
        });
    },
}

export default actions;
